export class ContactRequestDto {
    fullName: string;
    phoneNumber: string;
    email: string;
    age: string;
    contactType: string;
    questionAnswers = new Array<QuestionAnswer>();
}

export class QuestionAnswer {

    question: string;
    answer: string;
}
